export default __webpack_public_path__ + "static/media/Danger.b52bb97e.svg";